import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentSession, signOut } from './cognito';

const ROLE_LABEL = {
  parent: 'Parent Account',
  consultant: 'Consultant',
  admin: 'Admin',
};

// Reads the current Cognito session for a portal sidebar. RequireAuth has
// already gated the route, so `user` is expected to be populated by the
// time the portal finishes mounting.
export default function usePortalUser() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getCurrentSession().then((u) => {
      if (!cancelled) setUser(u);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSignOut = useCallback(() => {
    signOut();
    navigate('/login', { replace: true });
  }, [navigate]);

  return {
    name: user?.name || '…',
    email: user?.email || '',
    role: user ? ROLE_LABEL[user.group] || 'Member' : '',
    signOut: handleSignOut,
  };
}
